import {
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
} from "@mui/material";
import React from "react";
import { ModalWrapper } from "components/modalWrapper";
import { CheckCircleIcon } from "components/CheckCircleIcon";

export interface CajuCiclosModalProps {
  open: boolean;
  onClose: () => void;
}

export const CajuCiclosModal = (props: CajuCiclosModalProps) => {
  const cajuCiclosList = [
    "Admissão digital facilitada",
    "Gestão de dados e documentos do colaborador",
    "Assinatura digital integrada com validade jurídica",
    "Gestão de férias e ausências",
    "Relatórios para análises estratégicas",
  ]

  return (
    <ModalWrapper
      title="Gestão de pessoas na Caju"
      subtitle="A plataforma ideal para empresas que querem uma gestão de RH mais eficiente e segura."
      open={props.open}
      handleClose={props.onClose}
    >
      <Paper variant="outlined" sx={{ p: 3, borderRadius: '20px' }}>
        <Typography variant="subtitle2" color="dark.dark" marginBottom={1}>
          Funcionalidades e benefícios:
        </Typography>
        <List>
          {cajuCiclosList.map((benefit, index) => (
            <ListItem key={index} sx={{ py: '6px' }}>
              <ListItemIcon>
                <CheckCircleIcon />
              </ListItemIcon>
              <ListItemText
                primary={benefit}
                primaryTypographyProps={{
                  fontSize: 14,
                  color: "dark.light",
                }}
              />
            </ListItem>
          ))}
        </List>
      </Paper>
    </ModalWrapper>
  );
};
